import type { AnalyticsType, ChatTaggableKind } from '@orbit/api-types'
import type { ChatMention, ChatMessageSource, OutgoingMessage } from './types'

/** A send as the server takes it (`PostChatMessageSchema`). */
export interface PostChatMessageBody {
	clientId: string
	text?: string
	tags: { kind: ChatTaggableKind; id: number; mentions: ChatMention[] }[]
	photoIds: string[]
	quotedMessageId?: number
	previewsLink: boolean
	source: ChatMessageSource
	analytics?: AnalyticsType
}

/**
 * The body that sends `message`. Tags go by kind and id in the order tagged, a name tag
 * with where its `@Name`s sit; photos by the ids their upload returned, in order. A
 * Message of cards or photos alone sends no text at all. `analytics` is the device
 * context the server records `chat_message_sent` with.
 */
export const postMessageBody = (
	clientId: string,
	message: OutgoingMessage,
	photoIds: string[],
	analytics?: AnalyticsType,
): PostChatMessageBody => ({
	clientId,
	...(message.text != null && { text: message.text }),
	tags: message.cards.flatMap(card =>
		card.kind === 'Other' ? [] : [{ kind: card.kind, id: card.id, mentions: card.kind === 'Member' ? card.mentions : [] }],
	),
	photoIds,
	...(message.quote && { quotedMessageId: message.quote.id }),
	previewsLink: message.previewsLink,
	source: message.source,
	...(analytics && { analytics }),
})
